// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"3435457c","329":"3435457c","926":"3435457c","975":"d897af9c"}[chunkId] + ".chunk.css";
};